<template>
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar></sidebar>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title" :title1="title1" />
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-6 col-sm-6 col-12">
                <div class="form-group">
                  <label>Unit Name</label>
                  <input type="text" v-model="form.unitname" />
                </div>
              </div>
              <div class="col-lg-6 col-sm-6 col-12">
                <div class="form-group">
                  <label>Unit Code</label>
                  <input type="text" v-model="form.unitcode" />
                </div>
              </div>
              <div class="col-lg-12">
                <div class="form-group">
                  <label>Description</label>
                  <textarea class="form-control" v-model="form.description"></textarea>
                </div>
              </div>

              <div class="col-lg-12">
                <a v-on:click="postData()" class="btn btn-submit me-2">Submit</a>
                <router-link to="unitlist" class="btn btn-cancel">Cancel</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.headers.post["Content-Type"] = "application/json;charset=utf-8";

export default {
  data() {
    return {
      form: {
        unitname: "",
        unitcode: "",
        description: "",
      },
      id: this.$route.query.id,
      title: "Item Edit Unit",
      title1: "Edit an item unit",
    };
  },
  methods: {
    postData() {
      if (!this.form.unitname) {
        Swal.fire("Please enter the unit name");
        return;
      }
      axios
        .put("/v1/units/" + this.id, this.form)
        .then(() => {
          Swal.fire("Unit updated successfully");
          this.$router.push({ path: "/unitlist" });
        })
        .catch((error) => {
          console.log(error);
          Swal.fire(error.response?.data?.detail || "Could not update unit");
        });
    },
    async getUnitById(id) {
      axios
        .get("/v1/units/" + id)
        .then((response) => {
          this.form = response.data;
        })
        .catch((error) => {
          console.log(error);
          this.errored = true;
        });
    },
  },
  beforeMount() {
    this.id = this.$route.query.id;
    this.getUnitById(this.id);
  },
  name: "editunit",
};
</script>
